const API_BASE_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:8080'}/api`;

export const uploadImage = async (file: File, token: string): Promise<string> => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const response = await fetch(`${API_BASE_URL}/upload/image`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      body: formData,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || '이미지 업로드에 실패했습니다.');
    }

    const data = await response.json();
    return data.url;
  } catch (error) {
    if (error instanceof Error) {
      throw error;
    }
    throw new Error('이미지 업로드 중 오류가 발생했습니다.');
  }
};
